import(/* webpackMode: "eager" */ "/var/app/staging/app/(with-metadata)/(main)/privacy-policy/page.tsx");
